export default __webpack_public_path__ + "static/media/gallery12.57f7f238.jpg";